<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Open Customer Invoices Report</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="filteredOpenCustInvDetailList"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="openCustomerInvoiceDetailLists.length >= 50"
          stripedRows
          [rowHover]="true"
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Invoice#</th>
              <th>Sales Order</th>
              <th>Project Name</th>
              <th>Customer Account</th>
              <th>Name</th>
              <th>Date</th>
              <th>Due Date</th>
              <th>Amount In Transaction Currency</th>
              <th>Currency</th>
              <th>Interest</th>
              <th>Payments</th>
              <th>Amount</th>
              <th
                [ngClass]="{ trimmedby50char: descriptionCharacterCond }"
                class="jname text-center">
                Note
              </th>
              <th>Invoice Email Address</th>
              <th>Days Outstanding</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <jni-date-filter
                  [dataList]="openCustomerInvoiceDetailLists"
                  [filteredDataList]="filteredOpenCustInvDetailList"
                  [columnName]="dateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <jni-date-filter
                  [dataList]="openCustomerInvoiceDetailLists"
                  [filteredDataList]="filteredOpenCustInvDetailList"
                  [columnName]="dueDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-openCustomerInvoiceDetailLists
            let-rowIndex="rowIndex">
            <tr class="p-selectable-row">
              <td>
                <a
                  class="link"
                  (click)="
                    getInvoiceReport(
                      openCustomerInvoiceDetailLists.invoiceNumber
                    )
                  ">
                  {{ openCustomerInvoiceDetailLists.invoiceNumber }}
                </a>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToSaleorder(
                      openCustomerInvoiceDetailLists.salesOrder
                    )
                  ">
                  {{ openCustomerInvoiceDetailLists.salesOrder }}
                </a>
              </td>
              <td>{{ openCustomerInvoiceDetailLists.projectName }}</td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClient(
                      openCustomerInvoiceDetailLists.customerAccount
                    )
                  ">
                  {{ openCustomerInvoiceDetailLists.customerAccount }}
                </a>
              </td>
              <td>{{ openCustomerInvoiceDetailLists.name }}</td>
              <td>
                {{ openCustomerInvoiceDetailLists.date | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{
                  openCustomerInvoiceDetailLists.dueDate | date: "MM-dd-yyyy"
                }}
              </td>
              <td class="align-right">
                {{
                  openCustomerInvoiceDetailLists.amountInTransactionCurrency
                    | number: "1.2-2"
                }}
              </td>
              <td>{{ openCustomerInvoiceDetailLists.currency }}</td>
              <td class="align-right">
                {{ openCustomerInvoiceDetailLists.interest | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ openCustomerInvoiceDetailLists.payments | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{
                  openCustomerInvoiceDetailLists.amountNotSettled
                    | number: "1.2-2"
                }}
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }"
                class="name">
                {{
                  descriptionCharacterCount(
                    openCustomerInvoiceDetailLists.note
                  )
                }}{{ openCustomerInvoiceDetailLists.note }}
              </td>
              <td>{{ openCustomerInvoiceDetailLists.invoiceEmailAddress }}</td>
              <td>{{ openCustomerInvoiceDetailLists.daysOutstanding }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      [isModal]="true"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
